module.exports = __webpack_public_path__ + "static/img/works-03.059804b6.png";